// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var TaxCorrectionController = function($scope, $http, $routeParams, $window, $location, $interval, Contract, gettext) {
    var updateStatus = function() {
        $http({
            method: "GET",
            url: "api/v1/TaxCorrection",
            cache: false
        }).then(function (response) {
            $scope.state = response.data;
        })
    }

    $scope.report = function() {
        $http({
            method: "POST",
            url: "api/v1/TaxCorrection/report",
            data: $scope.options,
            cache: false
        }).then(function () {
            $location.path("/activities/reporting-files");
        });
    }

    $scope.cancel = function() {
        $window.history.back();
    };

    $scope.isReady = function() {
        return $scope.state && $scope.contract !== undefined;
    }

    $scope.execute = function() {
        $http({
            method: "POST",
            url: "api/v1/TaxCorrection/execute",
            params: { contractId: $routeParams.contractId},
            data: $scope.options,
            cache: false
        }).then(function () {
            updateStatus();
        });
    }
    
    function cancelOnNavigation(interval) {
        $scope.$on('$routeChangeStart', function() {
            $interval.cancel(interval);
        });
    }

    $scope.selectedTab = 'correction';
    $scope.options = {
        ArchiveOnly: false,
        PreservedPriceTaxType: "",
        Locale: "de-DE",
    };
    updateStatus();

    if($routeParams.contractId) {
        Contract.get({contractId: $routeParams.contractId}, function (data) {
            $scope.contract = data;
        });
    }
    else {
        $scope.contract = null;
    }

    cancelOnNavigation($interval(updateStatus, 10000));

    gettext("Ready");
    gettext("Queued");
    gettext("InProgress");
    gettext("Error");
};
TaxCorrectionController.$inject = ['$scope', '$http', '$routeParams', '$window', '$location', '$interval', 'Contract', 'gettext'];